import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CategorySec = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  // Helper function to get localized name
  const getLocalizedName = (category) => {
    if (!category || !category.name) return "";
    
    // If name is a string (backward compatibility)
    if (typeof category.name === 'string') {
      return category.name;
    }
    
    // If name is an object with language keys
    if (typeof category.name === 'object') {
      // Return the name in current language, fallback to English, then first available
      return category.name[currentLanguage] || 
             category.name.en || 
             category.name.hi || 
             category.name.es || 
             category.name.zh || 
             "Category";
    }
    
    return "Category";
  };

  const allCategories = () => {
    setLoading(true);
    let data = "";

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/categories/get-all-categories`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        // Sort categories by sequence number if available
        const sortedCategories = (response.data || []).sort((a, b) => {
          const seqA = a.sequence || a.sequenceNum || 0;
          const seqB = b.sequence || b.sequenceNum || 0;
          return seqA - seqB;
        });
        setCategories(sortedCategories);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    allCategories();
  }, []);

  // Re-run effect when language changes to ensure proper sorting
  useEffect(() => {
    // Force re-render when language changes to update names
    setCategories(prev => [...prev]);
  }, [currentLanguage]);

  if (loading) return <CategorySkeleton />;
  
  return (
    <div className="w-full md:py-10 px-4 md:px-10 bg-white">
      <div className="p-4">
        <div className="grid grid-cols-3 md:grid-cols-7 gap-4 justify-items-center ">
          {categories.map((item, index) => {
            const categoryName = getLocalizedName(item);
            
            return (
              <div
                key={item._id}
                onClick={() => navigate(`/category/${item._id}`)}
                className="flex flex-col items-center text-center cursor-pointer group transition-all duration-300 hover:scale-105"
                title={categoryName}
              >
                <div className="flex items-center justify-center w-16 h-16 transition-all duration-300 ">
                  {item.catIconUrl ? (
                    <img
                      src={item.catIconUrl}
                      alt={categoryName}
                      className="object-contain w-full h-full"
                      onError={(e) => {
                        e.target.src = "https://via.placeholder.com/64x64.png?text=Icon";
                      }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                      </svg>
                    </div>
                  )}
                </div>
                <h1 className="font-caveat font-bold text-base md:text-lg text-[#232F3E] mt-3 line-clamp-2 group-hover:text-blue-600 transition-colors duration-300">
                  {categoryName}
                </h1>
                
                {/* Language indicator (for debugging/development) */}
                {/* Uncomment to see which language is being displayed */}
                {/* <span className="text-xs text-gray-400 mt-1">
                  {currentLanguage.toUpperCase()}
                </span> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategorySec;

const CategorySkeleton = () => {
  return (
    <div className="w-full md:py-10 px-4 md:px-10 bg-white">
      <div className="rounded-lg bg-[#FBFBFB] p-4">
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 justify-items-center">
          {[...Array(7)].map((_, i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-b from-gray-300 to-gray-200 animate-pulse mb-3"></div>
              <div className="w-24 h-4 bg-gray-200 rounded-full animate-pulse"></div>
              <div className="w-16 h-3 bg-gray-100 rounded-full animate-pulse mt-2"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};





// import React from "react";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const CategorySec = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate()
//   const allCategories = () => {
//     setLoading(true);
//     let data = "";

//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/categories/get-all-categories`,
//       headers: {},
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setCategories(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     allCategories();
//   }, []);

//   if (loading) return <CategorySkeleton />;
//   return (
//     <div className="w-full md:py-10 px-4 md:px-10 bg-white">
//       <div className="rounded-lg bg-[#FBFBFB] p-4">
//         <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 justify-items-center ">
//           {categories.map((item, index) => (
//             <div
//               key={index}
//               onClick={() => navigate(`/category/${item._id}`)}
//               className="flex flex-col items-center text-center cursor-pointer"
//             >
//               <div className="flex items-center justify-center">
//                 <img
//                   src={item.catIconUrl}
//                   alt={item.name}
//                   className="object-contain w-[64px] h-auto"
//                 />
//               </div>
//               <h1 className="font-caveat font-bold text-base md:text-xl text-[#232F3E] mt-3 ">
//                 {item.name}
//               </h1>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CategorySec;

// const CategorySkeleton = () => {
//   return (
//     <div className="flex f justify-around gap-10 p-6 bg-white rounded-2xl">
//       {[...Array(7)].map((_, i) => (
//         <div key={i} className="flex flex-col items-center space-y-3">
//           <div className="w-16 h-16 bg-gradient-to-b from-gray-300 to-gray-200 rounded-lg animate-pulse"></div>
//           <div className="w-20 h-4 bg-gray-200 rounded-full animate-pulse"></div>
//         </div>
//       ))}
//     </div>
//   );
// };
